import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "react-oidc-context";
import InfoBanner from "./InfoBanner";
import UserContext from "../../state/UserContext";
import adminApi from "../../api/dashboard/adminApi";
import impersonationHelper from "../../helpers/impersonationHelper";

function ImpersonationBanner() {
  const { t } = useTranslation();
  const userContext = useContext(UserContext);
  const auth = useAuth();

  const impersonation = userContext.user.impersonation;
  if (!impersonation) {
    return null;
  }

  const handleEndImpersonation = async () => {
    const api = new adminApi(auth.user?.access_token);
    try {
      await api.endImpersonation();
    } catch (error) {
      console.error(error);
    }

    impersonationHelper.clearSessionId();

    if (window.opener) {
      window.close();
    } else {
      window.location.href = "/admin/users";
    }
  };

  return (
    <InfoBanner colour="STANDARD" className="rounded-none border-l-4 mx-0 mb-0">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between w-full gap-2">
        <span>
          {t("Pages.Impersonation.BannerMessage", {
            targetName: userContext.user.fullName,
            adminName: impersonation.impersonatorFullName,
            defaultValue:
              "You are currently impersonating {{targetName}}. Signed in as admin: {{adminName}}.",
          })}
        </span>
        <button
          type="button"
          className="text-sm font-semibold underline whitespace-nowrap"
          onClick={handleEndImpersonation}
        >
          {t("Pages.Impersonation.EndButton", "End impersonation")}
        </button>
      </div>
    </InfoBanner>
  );
}

export default ImpersonationBanner;
